import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { SproutIllustration } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/illustrations/SproutIllustration'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: theme.spacing['72px'],
  gap: theme.spacing['16px'],
}))

const ClientListEmptyState: React.FC = () => {
  const theme = useTheme()
  return (
    <Container>
      <SproutIllustration showCircles={false} height={43} width={84} />
      <BodyText
        size={BodyTextSize.LARGE}
        color={theme.colors.textSecondary}
        text={
          <FormattedMessage defaultMessage='No results found' description='No clients found for the given filters' />
        }
      />
    </Container>
  )
}

export default ClientListEmptyState
